import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ChipModule } from "../chips/chips.module";
import { LinkModule } from "../link/link.module";
import { InputBoxComponent } from "./input-box.component";

@NgModule({
    declarations:[InputBoxComponent],
    imports:[CommonModule,LinkModule,ChipModule,FormsModule],
    exports:[InputBoxComponent]
})
export class InputBoxModule{
    constructor(){}
}